/* eslint-disable func-names */
/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
// import { gaWrapper } from 'helpers/analytics';
// eslint-disable-next-line no-unused-vars
import s from './Login.scss';
import Cookie from '../../utils/cookies';

class OnetapsigninV2 extends React.Component {
  constructor() {
    super();
    this.state = {
      signInSuccess: false,
      showSignInSuccess: false,
      jssoCrosswalkObj: '',
    };
    this.yoloTimeout = 5000;
    this.clientId =
      '103703403489-b4t4lt8mr05brqpcdrmsu0di54cmjv4f.apps.googleusercontent.com';
    this.OnetapsigninMod = null;
    this.didPromiseReturn = false;
    this.didOneTapPopUpShow = false;
    this.moduleName = 'google_one_tap';
    this.nextShowCookieName = 'oneTapNextShow';
    this.ru = 'bchjqhklhblchbhjglh1wbfbv';
    this.timerID = false;
    this.source = '';
    this.callOneTapSignOnPriority = true;
  }

  getJssoCrosswalkObj = () => {
    let jssoCrosswalkObj = '';
    if (typeof this.state.jssoCrosswalkObj === 'object') {
      jssoCrosswalkObj = this.state.jssoCrosswalkObj;
    } else if (typeof window.JssoCrosswalk === 'function') {
      jssoCrosswalkObj = !this.props.isWapView
        ? new window.JssoCrosswalk('toi', 'web')
        : new window.JssoCrosswalk('toi', 'WAP');
      this.setState({ jssoCrosswalkObj });
    }
    return jssoCrosswalkObj;
  };

  componentDidMount() {
    window.addEventListener('onetapsignin', this.initOneTap);
    window.addEventListener('click', this.closeOneTap);
    window.addEventListener('OneTapLogin.openOneTap', this.loadJsOnEvent);
    try {
      window.TimesApps.PopUpV2Manager.cmd.push(() => {
        if (
          window.TimesApps.PopUpV2Manager &&
          window.TimesApps.PopUpV2Manager?.register &&
          typeof window.TimesApps.PopUpV2Manager.register === 'function'
        ) {
          window.TimesApps.PopUpV2Manager.register(this.moduleName, () => {
            if (
              typeof window === 'object' &&
              window.TimesGDPR &&
              window.TimesGDPR.common.consentModule.gdprCallback
            ) {
              window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
                if (
                  !(
                    dataObj.isEUuser ||
                    (dataObj.userCountry === 'US' &&
                      dataObj.userRegion === 'CA')
                  ) ||
                  dataObj.consentGiven
                ) {
                  this.loadJs();
                } else if (
                  window &&
                  window.TimesApps.PopUpList &&
                  window.TimesApps.PopUpList[this.moduleName]
                ) {
                  window.TimesApps.PopUpList[
                    this.moduleName
                  ].callbacks.onShowCallback(false);
                }
              });
            }
          });
        }
      });
    } catch (error) {
      console.log('Error in registering onetap popup');
    }
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.closeOneTap);
    window.removeEventListener('onetapsignin', this.initOneTap);
    window.removeEventListener('OneTapLogin.openOneTap', this.loadJsOnEvent);
  }

  initOneTap = e => {
    //append the google oneTap API script to dom
    if (typeof window === 'undefined') {
      return;
    }
    this.callBack = e.customCallBack;
    this.customFallbackFn = e.customFallbackFn;
    this.source = '';
    if (typeof e.source === 'string' && e.source) {
      this.source = e.source;
    }
  };

  closeOneTap = e => {
    // cancel if popup available.
    const el =
      e.target &&
      typeof e.target.closest === 'function' &&
      e.target.closest('#credential_picker_iframe');
    if (!el) {
      this.setTimerToClosePopup();
    }
  };

  loadJsOnEvent = () => {
    if (
      typeof window === 'object' &&
      window?.TimesGDPR?.common?.consentModule?.gdprCallback
    ) {
      window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
        if (
          !(
            dataObj.isEUuser ||
            (dataObj.userCountry === 'US' && dataObj.userRegion === 'CA')
          ) ||
          dataObj.consentGiven
        ) {
          this.loadJs(false);
        }
      });
    }
  };

  loadJs = (fromPopup = true) => {
    document.cookie =
      'g_state=; Path=/; Expires=Thu, 01 Jan 1900 00:00:01 GMT;';
    setTimeout(() => {
      this.initiateAPI(fromPopup);
    }, 200);
  };

  googleCallBack = response => {
    if (
      typeof response.credential !== 'undefined' &&
      this.getJssoCrosswalkObj &&
      typeof this.getJssoCrosswalkObj() === 'object' &&
      typeof this.getJssoCrosswalkObj().GisLogin === 'function'
    ) {
      this.getJssoCrosswalkObj().GisLogin(
        this.clientId,
        response.credential,
        'onetap',
        null,
        res => {
          if (res?.code === 200) {
            this.setUserLoginSession();
          }
        },
      );
      this.didPromiseReturn = true;
      this.didOneTapPopUpShow = true;
      window.onetapActiveFlag = false;
    }
  };

  setUserLoginSession = () => {
    if (typeof this.callBack === 'function') {
      this.callBack(false, () => {
        this.setState({
          signInSuccess: true,
          showSignInSuccess: true,
        });
        if (typeof window !== 'undefined' && window.location) {
          window.location.reload();
        }
      });
      setTimeout(() => {
        this.hideSignInSuccess();
      }, 10000);
    }
  };

  initiateAPI = (fromPopup = true) => {
    const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
    if ((!!ssoid || typeof window.google !== 'object') && fromPopup) {
      this.handleSigninFailure();
      return;
    }
    if (
      typeof window.google?.accounts?.id?.initialize === 'function' &&
      typeof window.google?.accounts?.id?.prompt === 'function'
    ) {
      window.google.accounts.id.initialize({
        client_id: this.clientId,
        callback: this.googleCallBack,
        cancel_on_tap_outside: false,
        itp_support: true,
        auto_select: true,
        use_fedcm_for_prompt: false,
        use_fedcm_for_button: true,
      });
      window.google.accounts.id.prompt(notification => {
        this.handleGoogleNotificationResponses(notification, fromPopup);
      });
    }
  };
  setTimerToClosePopup = () => {
    if (
      window.google &&
      window.google.accounts &&
      window.google.accounts.id &&
      typeof window.google.accounts.id.cancel === 'function'
    ) {
      window.google.accounts.id.cancel();
      window.onetapActiveFlag = false;
      if (this.timerID) {
        clearTimeout(this.timerID);
      }
    }
  };

  handleGoogleNotificationResponses = (notification, fromPopup = true) => {
    const getNotDisplayedReason = notification.getNotDisplayedReason();
    console.log('Google Notification', getNotDisplayedReason);
    // const getSkippedReason = notification.getSkippedReason();
    // const getDismissedReason = notification.getDismissedReason();
    if (notification && notification.g === 'display' && notification.h) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: 'google_one_tap',
        category: 'login_flow',
        label: this.props.isWapView ? 'mweb' : 'web',
      });
      if (
        window &&
        fromPopup &&
        window.TimesApps.PopUpList &&
        window.TimesApps.PopUpList[this.moduleName]
      ) {
        window.TimesApps.PopUpList[this.moduleName].callbacks.onShowCallback(
          true,
        );
      }
      this.timerID = setTimeout(this.setTimerToClosePopup, 90000);
      window.onetapActiveFlag = true;
      return;
    }
    // let label = `Success_google_iswap=${this.props.isWapView}`;

    // if (this.source && this.callOneTapSignOnPriority) {
    //   label = `Success_${this.props.isWapView ? 'wap' : 'web'}_${this.source}`;
    // }
    if (
      notification &&
      notification.g === 'dismissed' &&
      notification.i === 'credential_returned'
    ) {
      // analyticsWrapper('gaAndGrx', 'send', 'event', 'Login', 'One_Tap', label);
      analyticsWrapper('ga4', {
        event: 'user_login',
        type: 'google_one_tap',
        category: 'google_one_tap',
        label: 'login',
      });
    }
    if (notification.isNotDisplayed()) {
      this.handleSigninFailure(fromPopup);
    }
  };

  handleSigninFailure = (fromPopup = true) => {
    if (
      window &&
      fromPopup &&
      window.TimesApps.PopUpList &&
      window.TimesApps.PopUpList[this.moduleName]
    ) {
      window.TimesApps.PopUpList[this.moduleName].callbacks.onShowCallback(
        false,
      );
    }
    const { showCommentsSidebar } = this.props;
    if (typeof showCommentsSidebar === 'function') {
      showCommentsSidebar();
    }
    if (typeof this.customFallbackFn === 'function') {
      this.customFallbackFn();
    }
  };

  hideSignInSuccess = () => {
    this.setState({ showSignInSuccess: false });
  };

  render() {
    if (
      !(
        this.state.signInSuccess &&
        this.props.username &&
        this.state.showSignInSuccess
      )
    ) {
      return null;
    }
    return (
      <div className="onetap_wrapper">
        <span className="success" />
        <span className="text">
          {`Successfully signed in as ${this.props.username}`}
        </span>
        <span className="close" onClick={() => this.hideSignInSuccess()} />
      </div>
    );
  }
}

OnetapsigninV2.propTypes = {
  username: PropTypes.string,
};

OnetapsigninV2.defaultProps = {
  username: '',
};

export default OnetapsigninV2;
